import { Menu } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Sheet } from "@themes/pollinator/ui/Sheet";
import { PollinatorLogo } from "@themes/pollinator/ui/PollinatorLogo";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { ChatButtonContainer } from "@platform/features/chat";

export type Props = {
  // Pass navigation component as children
  children: React.ReactNode;
  isChatDisabled: boolean;
  isMobileMenuOpen: boolean;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
};

export function DashboardHeader({
  children,
  isChatDisabled,
  isMobileMenuOpen,
  openMobileMenu,
  closeMobileMenu,
}: Props) {
  return (
    <OuterContentContainer
      as="header"
      className="border-b border-brand-800 py-4 md:py-0"
    >
      <div className="flex items-center justify-between w-full md:py-4">
        <a
          href="/dashboard"
          data-testid="dashboard-header-home"
          title="Dashboard"
          aria-label="Dashboard"
          className="with-ring focus:rounded-lg focus:ring-offset-[8px]"
        >
          <PollinatorLogo size="md" />
        </a>

        {/* DESKTOP NAVIGATION */}
        <div className="hidden w-full justify-between gap-2 md:flex">
          {children}
        </div>

        {/* MOBILE NAVIGATION */}
        <div className="flex items-center gap-2">
          <ChatButtonContainer
            containerClassName="md:hidden"
            isChatDisabled={isChatDisabled}
          />

          <Button
            variant="ghost"
            iconComponent={Menu}
            className="size-max md:hidden"
            onClick={openMobileMenu}
            data-testid="dashboard-header-mobile-menu-open"
          />
        </div>
        <Sheet isOpen={isMobileMenuOpen} onClose={closeMobileMenu}>
          {children}
        </Sheet>
      </div>
    </OuterContentContainer>
  );
}

export default DashboardHeader;


